// frontend/src/components/dashboard/StatsCards.js

import React from 'react';

function StatsCards({ stats }) {
  const cards = [
    { 
      label: 'TOTAL LEADS', 
      value: stats?.total || 0, 
      icon: 'fa-users',
      bg: 'linear-gradient(135deg, #2B7AB5, #48A0DC)'
    },
    { 
      label: 'NEEDS DEMO', 
      value: stats?.needs_demo || 0, 
      icon: 'fa-calendar-plus',
      bg: 'linear-gradient(135deg, #48A0DC, #6AB8E8)'
    },
    { 
      label: 'UPCOMING DEMOS', 
      value: stats?.upcoming_demos || 0, 
      icon: 'fa-clock',
      bg: 'linear-gradient(135deg, #6AB8E8, #8ACCF0)'
    },
    { 
      label: 'WON', 
      value: stats?.won_count || 0, 
      icon: 'fa-trophy',
      bg: 'linear-gradient(135deg, #1A5A8A, #2B7AB5)'
    },
  ];

  return (
    <div className="stats-grid">
      {cards.map((card, index) => (
        <div className="stat-card" key={index}>
          <div className="stat-icon" style={{ background: card.bg }}>
            <i className={`fas ${card.icon}`}></i>
          </div>
          <div className="stat-info">
            <div className="stat-value">{card.value.toLocaleString()}</div>
            <div className="stat-label">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StatsCards;